"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredErrorState = requiredErrorState;
exports.searchableSelectInvalidSelectionState = searchableSelectInvalidSelectionState;
exports.invalidInputState = invalidInputState;
exports.validState = void 0;
var validState = {
  type: null,
  msg: null
};
exports.validState = validState;

function requiredErrorState(label) {
  return {
    type: "error",
    msg: label ? "".concat(label, " is required") : "Field is required"
  };
}

function searchableSelectInvalidSelectionState(selection) {
  return {
    type: "error",
    msg: "'".concat(selection, "' is an invalid selection")
  };
}

function invalidInputState(label) {
  return {
    type: "error",
    msg: "".concat(label, " is invalid")
  };
}